import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { GlobalErrorHandler } from 'src/app/theme/shared/_helpers/global-error.handler';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';

// project import
import { AppRoutingModule } from './app/app-routing.module';
import { SharedModule } from './app/theme/shared/shared.module';
import { AppComponent } from './app/app.component';
import { LoaderInterceptor } from 'src/app/theme/shared/_helpers/loader.interceptor';
import { AuthTokenInterceptor } from 'src/app/theme/shared/_helpers/auth-token.interceptor';
import { BasicAuthInterceptor } from 'src/app/theme/shared/_helpers/basic-auth.interceptor';
import { ErrorInterceptor } from 'src/app/theme/shared/_helpers/error.interceptor';

// bootstrap import
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

// third party
import { ToastrModule } from 'ngx-toastr';
import { QuillModule } from 'ngx-quill';
import { provideSweetAlert2 } from '@sweetalert2/ngx-sweetalert2';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      SharedModule,
      NgbDropdownModule,
      NgbNavModule,
      NgbTooltipModule,
      NgbModule,
      ToastrModule.forRoot(),
      QuillModule.forRoot()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Render every `| date` pipe in UTC so server timestamps never shift across
    // day/month boundaries or at midnight depending on the viewer's timezone.
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: 'UTC' } },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    [provideHttpClient(withInterceptorsFromDi())],
    provideAnimations(),
    provideSweetAlert2({
      fireOnInit: false,
      dismissOnDestroy: true
    })
  ]
}).catch((err) => console.error(err));
